import { Notification } from '@yandex-int/k-common/typings/api/models';
import { getNotificationsList } from 'platform-components/src/components/notifications/selectors';
import { createSelector } from 'reselect';

import { getClassIdFromProps } from 'utils/selectors/selectors';

import { isDefaultDataNotification, isSchoolCodeUpdatedNotification } from './guards';

export const getIsSchoolCodeChanged = createSelector(
    [getNotificationsList, getClassIdFromProps],
    (notifications, classId: number): boolean => {
        const schoolCodeNotification = notifications.find(
            (notification) => isSchoolCodeUpdatedNotification(notification) && notification.data.team_id === classId
        );

        return Boolean(schoolCodeNotification);
    }
);

export const getFirstNotification = createSelector(getNotificationsList, (notifications): Notification | null => {
    for (const notification of notifications) {
        if (isDefaultDataNotification(notification)) {
            return notification;
        }
    }

    return null;
});
